import React, { useMemo } from "react"
import { useTheme } from "~/ui/styled"
import { ColumnFlex, CenterFlex, Text } from "~components/El"
import { Avatar } from "~widgets/avatar"
import { AttachTransData, TransferStatus } from "~proto"
import { formatDate } from "~utils"
import { PopupRoot, PopupImageBackground, PopupClose } from "../components/PopupShell"

const transferBg = require("~assets/images/chat/transfer_bg.png")

interface Props {
  transferData: AttachTransData
  onClose: () => void
}

const TransferDetailNoticePopup: React.FC<Props> = ({ transferData, onClose }) => {
  const theme = useTheme()

  const StatusTitle = useMemo(() => {
    if (transferData?.status === TransferStatus.EXPIRED) {
      return "该转账已超过24小时"
    } else if (transferData?.status === TransferStatus.REFUNDED) {
      return "该转账已超过24小时"
    } else if (transferData?.status === TransferStatus.RECEIVED) {
      return `您已收款`
    } else {
      return `待您收款`
    }
  }, [transferData])

  const StatusDesc = useMemo(() => {
    if (transferData?.status === TransferStatus.PENDING) {
      return "您有新的转账待收款"
    }
    return ""
  }, [transferData])

  return (
    <PopupRoot width="100%">
      <PopupImageBackground src={transferBg} resizeMode="cover">
        <ColumnFlex width="100%" height="100%" alignItems="center">
          <CenterFlex
            width="60px"
            height="60px"
            padding="2px"
            mt="60px"
            borderRadius="30px"
            bg={theme.colors.text}
          >
            <Avatar avatar={transferData?.sender_image} size={56} name={transferData?.sender_nickname} />
          </CenterFlex>

          <Text mt="8px" fontSize={14} color={theme.colors.text} fontWeight="600">
            {StatusTitle}
          </Text>
          <Text mt="5px" fontSize={14} color={theme.colors.secondary}>
            {transferData?.remark || ""}
          </Text>
          <Text mt="15px" fontSize={40} color={theme.colors.error} fontWeight="600">
            ¥{transferData.amount || "0"}
          </Text>
          {StatusDesc && (
            <Text mt="5px" fontSize={12} color={theme.colors.secondary}>
              {StatusDesc}
            </Text>
          )}
          <Text mt="5px" fontSize={10} color={theme.colors.secondary}>
            转账时间: {formatDate(transferData.created, "s")}
          </Text>
          {transferData.received_time && (
            <Text mt="5px" fontSize={10} color={theme.colors.secondary}>
              收款时间: {formatDate(transferData.received_time, "s")}
            </Text>
          )}
        </ColumnFlex>
      </PopupImageBackground>
      <PopupClose onClose={onClose} />
    </PopupRoot>
  )
}

export default TransferDetailNoticePopup
